module.exports = __webpack_public_path__ + "media/fonts/suisse-intl/SuisseIntl-ThinItalic-WebM-50ec6a038d1ab0926bdc46dfbb952f41.woff2";